exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-fixed{font-size:16px;text-transform:uppercase;font-weight:700;color:#fff;border-radius:5px;letter-spacing:2px;background-color:rgba(233,30,98,.4235294117647059);padding:18px 30px;position:fixed;bottom:40px;right:40px;transition:all .3s ease 0ms;box-shadow:0 8px 15px rgba(0,0,0,.1);z-index:99}.btn-fixed:hover{background-color:#df438b;box-shadow:0 15px 20px rgba(0,0,0,.3);transform:translateY(-7px);text-decoration:none;color:#fff;cursor:pointer}.btn-block{font-size:11px}", ""]);

// exports
